import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Link,
  IconButton,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const ContactUs = () => {
  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      <Paper
        elevation={6}
        sx={{

          p: { xs: 5, sm: 7 },
          textAlign: "center",
          borderRadius: 4,
        }}
      >
        <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold", color: "#007bff", mb: 3 }}>
          Contact Us
        </Typography>

        <Typography variant="h6" sx={{ mb: 4 }}>
          We would love to hear from you! Feel free to reach out for any inquiries or just to say hello.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
          Phone: +91 9359862291
        </Typography>

        <Typography variant="h6" sx={{ mb: 4 }}>
          Email:{" "}
          <Link
            href="mailto:hr@nexexcellency.com"
            underline="hover"
            sx={{ color: "#007bff", fontWeight: "bold", fontSize: "1.2rem" }}
          >
            hr@nexexcellency.com
          </Link>
        </Typography>

        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: "bold", mr: 1 }}>
            Find us on LinkedIn
          </Typography>
          <IconButton
            href="https://www.linkedin.com/company/nexexcellency-private-limited"
            target="_blank"
            rel="noopener"
            sx={{ color: "#0A66C2" }}
          >
            <LinkedInIcon sx={{ fontSize: 40 }} />
          </IconButton>
        </Box>
      </Paper>
    </Container>
  );
};

export default ContactUs;
